export const formatPercent = value => `${Number(value || 0).toFixed(2)}% `
